// Helpers de tema para os graficos da Dashboard.
// Centraliza cores de texto/grade conforme o tema (claro/escuro) e a legenda
// fixa de volume usada pelos graficos coloridos por tercil.

import { i18n } from "../../translate/i18n";

export const LOW_VOLUME_COLOR = "#009ACC";
export const MID_VOLUME_COLOR = "#CCBE00";
export const HIGH_VOLUME_COLOR = "#CC0036";

// No tema escuro o texto preto padrao do Chart.js fica ilegivel sobre o fundo
// escuro: usar tom claro. No tema claro, cinza escuro.
export const getChartTextColor = isDark => (isDark ? "#e0e0e0" : "#333333");

export const getChartGridColor = isDark =>
  isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)";

// O backend manda o dia da semana abreviado sempre em pt ("Dom", "Seg", ...,
// "Sab"): traduz só o rótulo exibido; valor desconhecido passa como veio.
const WEEKDAY_SHORT_KEYS = {
  Dom: "dashboard.charts.weekDayShort.sun",
  Seg: "dashboard.charts.weekDayShort.mon",
  Ter: "dashboard.charts.weekDayShort.tue",
  Qua: "dashboard.charts.weekDayShort.wed",
  Qui: "dashboard.charts.weekDayShort.thu",
  Sex: "dashboard.charts.weekDayShort.fri",
  Sab: "dashboard.charts.weekDayShort.sat",
  "Sáb": "dashboard.charts.weekDayShort.sat"
};

export const translateWeekDayShort = label =>
  WEEKDAY_SHORT_KEYS[label] ? i18n.t(WEEKDAY_SHORT_KEYS[label]) : label;

// Legenda fixa (3 cores) para os graficos de uma unica serie cujas barras sao
// coloridas por tercil (menor/medio/maior volume). generateLabels do Chart.js
// espera itens neste formato; onClick e no-op pois nao ha dataset para togglar.
export const buildVolumeLegend = textColor => ({
  display: true,
  position: "top",
  onClick: () => {},
  labels: {
    color: textColor,
    generateLabels: () => [
      {
        text: i18n.t("dashboard.charts.volume.low"),
        fillStyle: LOW_VOLUME_COLOR,
        strokeStyle: LOW_VOLUME_COLOR,
        fontColor: textColor
      },
      {
        text: i18n.t("dashboard.charts.volume.mid"),
        fillStyle: MID_VOLUME_COLOR,
        strokeStyle: MID_VOLUME_COLOR,
        fontColor: textColor
      },
      {
        text: i18n.t("dashboard.charts.volume.high"),
        fillStyle: HIGH_VOLUME_COLOR,
        strokeStyle: HIGH_VOLUME_COLOR,
        fontColor: textColor
      }
    ]
  }
});
